export default {
  key: 'LastSearches',
  maxItems: 5,
  keypressTimeout: null,
  loadedRVIItems: false,
};
